<template>
  <b-row class="justify-content-xl-center">
  <b-col class="col-xl-10">

      <h3>Bestätigungslink erneut senden</h3>

      <p>
        Sollten Sie den Link zur Bestätigung Ihrer Emailadresse nicht erhalten haben,
        können Sie ihn hier erneut anfordern. Geben Sie dazu bitte die Emailadresse ein,
        die Sie zur Registrierung verwendet haben:
      </p>

      <b-form id="login" autocomplete="on">
        <b-form-group label-for="email" label="Email">
          <b-form-input type="text" id="email" v-model="email" autocomplete="email"/>
        </b-form-group>

        <b-button type="button" v-on:click="send" :disabled="!this.email.includes('@')" variant="primary" class="float-right">Email senden</b-button>
      </b-form>

  </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'Resend',
    data: function () {
      return {
        email: ''
      }
    },

    methods: {
      send: function () {
        this.axios.post('/registration/resend', JSON.stringify({email: this.email}))

          .then(() => {
            this.$eventHub.$emit('info', 'Email erfolgreich versendet')
          })

          .catch((err) => {
            this.$eventHub.$emit('error', err)
          })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/guests/registration/Resend.vue